
import { Product } from "@/types/product";

export const ipaSFPRJ451: Product = {
  id: "ipa-sfp-rj45-1",
  groupId: "avoip",
  name: "IPA-SFP-RJ45-1",
  subtitle: "1Gbps Copper SFP Module",
  description: "1Gbps Copper SFP Module RJ-45 for VPX-TC1-CF.\n\nFor use with VPX series with an SFP slot. Previously P/N IPX-SFP-RJ45-1. Enables SFP slot to be converted into a LAN port",
  features: [
    "Compatible with all VPX devices",
    "Converts SFP port to RJ-45",
    "Hot-swappable design",
    "Simple plug-and-play operation",
    "No configuration required"
  ],
  images: ["/lovable-uploads/3914e462-1345-4c45-b5ec-6fec113962d3.png"],
  slug: "ipa-sfp-rj45-1",
  networkSpeed: "vpx-accessories"
};
